import { ModalSpinner } from "components/ModalSpinner";
import { Suspense } from "react";

export const SuspenseWrapper = ({ children }) => (
  <Suspense fallback={<ModalSpinner open={true} />}>{children}</Suspense>
);
